export const getFractionDigits = (currency, locale) => {
    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
        }).resolvedOptions();
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return {
            currency,
            locale: locale || '',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            minimumIntegerDigits: 1,
            numberingSystem: 'latn',
            style: 'currency',
            useGrouping: true,
        };
    }
};
export const getFormattedAmount = (amount, currency, locale, options) => {
    const { minimumFractionDigits, maximumFractionDigits } = getFractionDigits(currency, locale);
    return amount.toLocaleString(locale, {
        minimumFractionDigits,
        maximumFractionDigits,
        ...options,
    });
};
export const getAmountWithMinimumDecimals = (amount, currency, locale, options) => {
    const { minimumFractionDigits } = getFractionDigits(currency, locale);
    return amount.toLocaleString(locale, {
        minimumFractionDigits,
        maximumFractionDigits: 20,
        ...options,
    });
};
